module.exports = __webpack_public_path__ + "static/media/loanIco.39dc8e3c.svg";